import { json } from "react-router-dom";
import { get, post, put } from "../Service/ApiConfig";
import { LocationEndPoint } from "../Service/Endpoints/ApiEndPoints";

export const getAllLocations = async ({ page, size, searchText, language }) => {
  const response = await get(
    LocationEndPoint.GetLocations(page, size, searchText, language),
  );
  return response;
};

export const getLocationByID = async ({id}) => {
  const response = await get(LocationEndPoint.getLocationByID(id));
  return response;
};

export const activationStatLocation = async ({ id, activeStatus }) => {
  const response = await put(
    LocationEndPoint.ActivationLocation,
    JSON.stringify({
      id: id,
      isActive: activeStatus,
    }),
  );

  return response;
};

export const updateLocation = async ({ clinicLocation }) => {
  console.log("update data",clinicLocation)
  const response = await put(
    LocationEndPoint.updateLocation,
    JSON.stringify(clinicLocation),
  );
  return response;
};

export const getAllDistrict = async(provinceId) => {
  const response = await get(LocationEndPoint.GetDistricts(provinceId));
  return response;
};

export const getAllProvince = async() => {
  const response = await get(LocationEndPoint.GetProvince());
  return response;
}

export const getAllCityBasedOnDistrict = async(districtId) => {
  const response = await get(LocationEndPoint.GetCities(districtId));
  return response;
}

export const addLocation = async({clinicLocation}) => {
  const response = await post(
    LocationEndPoint.AddLocation,
    JSON.stringify(clinicLocation)
  )
  return response;
}